<template>
  <!-- 修改定制商品对话框 -->
  <el-dialog
      title="修改定制商品"
      :visible.sync="editDialogVisible"
      width="80%"
  >
    <el-form ref="editFormRef" :rules="rules" :model="editForm" label-width="120px">
      <el-row>
        <el-col :span="12">
            <el-form-item label="定制商品名称" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入定制商品名称"/>
            </el-form-item>
        </el-col>
        <!--缩略图-->
        <el-col :span="24" class="label">
          <el-form-item label="缩略图">
            <thumbnail v-model="editForm.thumbnail" :md5s="editForm.thumbnail"></thumbnail>
          </el-form-item>
        </el-col>
        <!--轮播图-->
        <el-col :span="24" class="label">
          <el-form-item label="轮播图">
            <thumbnail-list v-model="editForm.carousel" :md5List="editForm.carousel"></thumbnail-list>
          </el-form-item>
        </el-col>
        <!--排序-->
        <el-col :span="24">
          <el-form-item label="排序" prop="sort">
            <el-input v-model="editForm.sort" placeholder="请输入排序"/>
          </el-form-item>
        </el-col>
        <!--说明-->
        <el-col :span="24">
          <el-form-item label="说明">
            <Editor v-model="editForm.brief"></Editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="modifyCustomGoods">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {updateCustomGoods} from "@/api/customGoods/customGoods";
import {getPostOrDeleteData} from "@/utils/code";
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import Editor from '@/components/common/editor/editor'
import { customGoodsRules } from '@/js/rules'

export default {
  name: "editCustomGoods",
  components: { Thumbnail, ThumbnailList, Editor },
  data() {
    return {
      editForm: {}, //修改
      editDialogVisible: false,
      rules: customGoodsRules,
    }
  },
  methods: {
    cancel() {
      this.editDialogVisible = false
      this.editForm = {}
    },
    editDialog(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
    },
    modifyCustomGoods() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        updateCustomGoods(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response);
          if (data !== null) {
            this.$emit('refresh-list')
            this.editDialogVisible = false;
          }
        })
      });
    },
  }
}
</script>

<style scoped>

</style>
